import Server from '@/service/server'
import utility from '@/utilities/utility'

export default {
  namespaced: true,
  state: {
    isLoadingPage: false,
    isPageLoaded: false,
    isLoadingPageFailed: false,
    clickId: '',
    campaign: '',
    landingRefCode: '',
    userName: '',
    currentPage: {},
    subscriptionRequestResult: {
      subscriptionMethod: '',
      code: '',
      countryCode: '',
      numberLength: 10
    },
    requestStatus: 'None',
    isOtpVerified: false,
    trackingSessionId: null,
    trackingSessionEventOrder: 1,
    headerEnrichmentUsername: null
  },
  getters: {
    isPageLoaded (state: any) {
      return state.isPageLoaded
    },
    isLoadingPage (state: any) {
      return state.isLoadingPage
    },
    isLoadingPageFailed (state: any) {
      return state.isLoadingPageFailed
    },
    currentPage (state: any) {
      return state.currentPage
    },
    subscriptionMethod (state: any) {
      return state.subscriptionRequestResult.subscriptionMethod
    },
    validCountryCode (state: any) {
      return state.subscriptionRequestResult.countryCode
    },
    validPhoneNumberLength (state: any) {
      return state.subscriptionRequestResult.numberLength
    },
    requestStatus (state: any) {
      if (state.requestStatus === 'AwaitingConfirm' && state.isOtpVerified) {
        return 'Processing'
      }

      return state.requestStatus
    },
    headerUsername (state:any) {
      return state.headerEnrichmentUsername
    }
  },
  actions: {
    loadPage (context: any, payload: any) {
      // set loading landing page
      context.commit('loadingPageInfo')

      // loading landing page
      let promise = Server.getLandingPage({ url: payload.url, landingPageToken: payload.landingPageToken })
      promise.then((response: any) => {
        let page = response.body.result

        page.sections = page.sections.sort((s1: any, s2: any) => {
          return s1.order - s2.order
        })

        let requestPayload = {
          channel: 'LandingPage',
          planProviderCode: page.planProviderCode,
          pageCode: page.pageCode,
          clickId: context.state.clickId,
          campaign: context.state.campaign,
          channelName: page.url,
          callbackUrl: page.callbackUrl,
          landingRefCode: context.state.landingRefCode
        }

        context.commit('pageInfoReceived', page)

        // Track event
        context.dispatch('trackEvent', {
          eventType: 'PageVisited'
        })

        context.dispatch('subscription/requestForSubscription', requestPayload, { root: true }).then((requestResponse: any) => {
          let requestResult = requestResponse.body.result
          context.commit('subscriptionRequestResultReceived', requestResult)
          context.commit('subscription/requestResultReceived', requestResult, { root: true })

          // Track event
          context.dispatch('trackEvent', {
            eventType: 'SendingRequestSucceeded'
          })

          if (requestResult.subscriptionMethod === 'CG') {
            window.location.href = requestResult.redirectUrl
          }

          // check header enrichment
          if (requestResult.hasHeader === true) {
            if (requestResult.heUrl) {
              fetch(requestResult.url)
            }
            let numberOfAttempt = 0
            let timerId = setInterval(() => {
              numberOfAttempt += 1
              var params = { code: requestResult.code }
              var checkHeaderPromise = Server.checkHeaderEnrichmentUsername(params).then((result:any) => {
                if (result.username) {
                  context.commit('headerEnrichmentUsername', result.username)
                  clearInterval(timerId)
                } else if (numberOfAttempt == 10) {
                  clearInterval(timerId)
                }
              })
              return checkHeaderPromise
            }, 500)
          }
        }, (requestError: any) => {
          context.commit('loadingPageFailed')

          // Track event
          context.dispatch('trackEvent', {
            eventType: 'SendingRequestFailed'
          })
        })
      }, (error: any) => {
        context.commit('loadingPageFailed')
      })
      return promise
    },
    // checkHeaderEnrichmentUsername(context: any, code: string) {
    //   var params = { code: code };
    //   var promise = Server.checkHeaderEnrichmentUsername(params);//api alex
    //   promise.then((response: any) => {
    //     var result = response.body.result;
    //     context.commit("headerRequestStatusUpdated", result);
    //   });
    //   return promise;
    // },
    setTrackingInfo (context: any, payload: any) {
      context.commit('trackingInfoFetched', payload)
    },
    trackEvent (context: any, input: any) {
      if (input.eventType !== 'PageVisited' && context.state.trackingSessionId == null) {
        setTimeout(() => {
          context.dispatch('trackEvent', input)
        }, 1000)

        return
      }

      let payload = {
        eventType: input.eventType,
        order: context.state.trackingSessionEventOrder,
        sessionId: context.state.trackingSessionId,
        pageId: context.state.currentPage.id,
        subscriptionRequestCode: context.state.subscriptionRequestResult.code === '' ? null : context.state.subscriptionRequestResult.code,
        userName: context.state.userName === '' ? null : context.state.userName,
        clickId: context.state.clickId,
        landingRefCode: context.state.landingRefCode
      }

      let promise = Server.trackSessionEvent(payload)
      promise.then((response: any) => {
        context.commit('increaseTrackingSessionEventOrder')

        if (context.state.trackingSessionId !== null) { return }

        let sessionId = response.body.result
        context.commit('sessionIdReceived', sessionId)
      })
      return promise
    },
    init (context: any, payload: any) {
      let userName = payload.userName
      context.commit('userNameGethered', userName)

      payload.code = context.state.subscriptionRequestResult.code

      let promise = context.dispatch('subscription/init', payload, { root: true })
      promise.then((response: any) => {
        // Track event
        context.dispatch('trackEvent', {
          eventType: 'SendingInitSucceeded'
        })

        if (response.ok) {
          context.dispatch('checkRequestStatus')
        } else {
          let error = response.body.error

          if (error.message === 'Paroo.Subscription.AlreadySubscribed') {
            window.location.href = context.state.currentPage.redirectUrl + '?userName=' + context.state.userName
          }
        }
      })
      return promise
    },
    verify (context: any, otp: string) {
      let payload = {
        requesterServiceRefCode: context.state.subscriptionRequestResult.code,
        userInput: otp
      }

      let promise = context.dispatch('subscription/verify', payload, { root: true })
      promise.then((response: any) => {
        // Track event
        context.dispatch('trackEvent', {
          eventType: 'SendingOtpVerificationSucceeded'
        })

        if (response.body.result.status === 'Success') {
          context.dispatch('trackEvent', {
            eventType: 'SubscriptionSucceeded'
          })
        } else {
          context.dispatch('trackEvent', {
            eventType: 'OtpVerificationFailed'
          })
        }

        setTimeout(() => {
          context.dispatch('checkRequestStatus')
        }, 1000)
      }, (errorResponse: any) => {
        // Track event
        context.dispatch('trackEvent', {
          eventType: 'SendingOtpVerificationFailed'
        })
      })
      return promise
    },
    checkRequestStatus (context: any) {
      let promise = context.dispatch('subscription/checkRequestStatus', context.state.subscriptionRequestResult.code, { root: true })
      promise.then((response: any) => {
        let result = response.body.result
        context.commit('subscriptionRequestStatusUpdated', result)

        if (result === 'Init' || result === 'Processing' || result === 'Verified' || result === 'CheckPolicy') {
          setTimeout(() => {
            context.dispatch('checkRequestStatus')
          }, 2000)
        } else if (result === 'Finalized') {
          setTimeout(() => {
            if (context.state.currentPage.downloadUrl) {
              window.location.href = context.state.currentPage.downloadUrl
              setTimeout(() => {
                window.location.href = context.state.currentPage.redirectUrl + '?userName=' + context.state.userName
              }, 3000)
            } else {
              window.location.href = context.state.currentPage.redirectUrl + '?userName=' + context.state.userName
            }
          }, 1000)
        }
      })

      return promise
    }
  },
  mutations: {
    trackingInfoFetched (state: any, payload: any) {
      state.clickId = payload.clickId,
      state.campaign = payload.campaign,
      state.landingRefCode = utility.createGUID()
    },
    loadingPageInfo (state: any) {
      state.isLoadingPage = true
      state.isPageLoaded = false
      state.isLoadingPageFailed = false
    },
    loadingPageFailed (state: any) {
      state.isLoadingPage = false
      state.isPageLoaded = false
      state.isLoadingPageFailed = true
    },
    pageInfoReceived (state: any, landingPageInfo: any) {
      state.isLoadingPage = false
      state.isPageLoaded = true
      state.isLoadingPageFailed = false
      state.currentPage = landingPageInfo
    },
    subscriptionRequestResultReceived (state: any, payload: any) {
      state.subscriptionRequestResult = payload
    },
    subscriptionRequestStatusUpdated (state: any, status: string) {
      state.requestStatus = status
    },
    userNameGethered (state: any, userName: string) {
      state.userName = userName
    },
    sessionIdReceived (state: any, sessionId: number) {
      state.trackingSessionId = sessionId
    },
    increaseTrackingSessionEventOrder (state: any) {
      state.trackingSessionEventOrder++
    },
    otpVerified (state: any) {
      state.isOtpVerified = true
    },
    headerEnrichmentUsername (state: any, status: string) {
      state.headerEnrichmentUsername = status
    }
  }
}
